export const allTeamsSelector = (state: any) => state.team.allTeams;

export const selectedTeamSelector = (state: any) => state.team.team;
